<template>
  <div>
    <TopParallax
      title="TERMS OF USE"
      :img-src="imgSrc"
    />
    <TermsContent />
  </div>
</template>

<script>
import TopParallax from '@/components/TopParallax.vue'
import TermsContent from '@/components/TermsContent.vue'

export default {
  components: {
    TopParallax,
    TermsContent
  },
  data() {
    return {
      imgSrc: require('@/assets/images/placeholder.jpg')
    }
  },
  head: {
    title: function () {
      return {
        inner: 'Terms'
      }
    }
  }
}
</script>
